import { render, staticRenderFns } from "./PlpClearAllRefinements.vue?vue&type=template&id=1f492a0c&"
import script from "./PlpClearAllRefinements.vue?vue&type=script&lang=js&"
export * from "./PlpClearAllRefinements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports